import { Injectable, Renderer2 } from '@angular/core';

import { BaseGenerator } from './base.generator';

import { StructuredDataBreadcrumb } from '../interfaces/json-ld-breadcrumb.interface';

export type BreadcrumbStructuredDataEntityType =
  | 'EXHIBITOR'
  | 'CONTACT_PERSON'
  | 'EVENT'
  | 'CONTRIBUTOR'
  | 'POST'
  | 'PRODUCT';

export interface BreadcrumbStructuredDataListItem {
  '@type': 'ListItem';
  position: number;
  item: string;
  name: string;
}

export interface BreadcrumbListItem {
  label: string;
  routerLink: string[];
  queryParams?: { [key: string]: any };
  disabled?: boolean;
}

export interface BreadcrumbData {
  elements: BreadcrumbListItem[];
  structuredData: StructuredDataBreadcrumb;
}

@Injectable()
export class BreadcrumbGenerator extends BaseGenerator {
  constructor() {
    super('script', 'application/ld+json');
  }

  validateBreadcrumbStructuredData(renderer2: Renderer2, data: StructuredDataBreadcrumb, location: HTMLElement) {
    if (data.itemListElement && data.itemListElement?.length > 0) {
      super.setTag(renderer2, data, location);
    }
  }
}
